import React from "react";
import Image from "next/image";

export interface BadgeProps {
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>> | string;
  title?: string;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({ icon: Icon, title, className = "" }) => {
  return (
    <div
      className={`inline-flex items-center border border-border-default bg-surface-default text-text-body-subtle rounded-full px-2.5 py-1 text-sm font-medium ${className}`}
    >
      {Icon &&
        (typeof Icon === "string" ? (
          <Image
            src={Icon}
            alt=""
            width={16}
            height={16}
            className="w-4 h-4 mr-2"
          />
        ) : (
          <Icon className="w-4 h-4 mr-2" />
        ))}
      {title}
    </div>
  );
};
